import React from "react";

import Info from "assets/images/svg/info.svg";

const Alert = ({ className = "", icon = "", title = "", description = "" }) => {
    return (
        <div className={`${className} border-radius p-5`} style={{ backgroundColor: "#F0F1F2" }}>
            <div className="d-flex">
                {icon || <Info />}
                {title && <h6 className="mt-0 ml-3">{title}</h6>}
            </div>
            {description && <p className="text-14 mb-0">{description}</p>}
        </div>
    );
};

export default Alert;